import { render, staticRenderFns } from "./MasterAiAdvice.vue?vue&type=template&id=adc5aacc&scoped=true&"
import script from "./MasterAiAdvice.vue?vue&type=script&lang=ts&"
export * from "./MasterAiAdvice.vue?vue&type=script&lang=ts&"
import style0 from "./MasterAiAdvice.vue?vue&type=style&index=0&id=adc5aacc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc5aacc",
  null
  
)

export default component.exports